import { Footer2018 } from '../footer';
import { use2018Assets } from '../shared';

const Agenda2018Zh = () => {
  use2018Assets({
    lang: 'zh',
    title: '香港智慧城市峰會暨智慧城市大獎2018 - 峰會議程',
    variant: 'awards',
  });

  return (
    <>
      <div id="Lightbox">
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>

      <div className="menu_container" id="menu_container">
        <div className="topnav" id="myTopnav">
          <a href="/2018/zh" className="topnav_logo" id="topnav_logo">
            <img src="/2018/images/head_logo_2.png" alt="" />
          </a>
          <div className="tab_container" id="tab_container">
            <a href="/2018/zh" id="tab_home">
              主頁
            </a>
            <a href="/2018/zh/agenda">峰會</a>
            <a href="/2018/zh/awards" className="tab_awards">
              獎項
            </a>
            <a href="/2018/zh/winners" className="tab_winners">
              得獎名單
            </a>
            <a href="/2018/zh/advisory">諮詢委員會</a>
            <div className="dropdown">
              <a href="#" className="dropbtn">
                評審委員會
              </a>
              <div className="dropdown-content">
                <a href="/2018/zh/judges">評審</a>
                <a href="/2018/zh/judges_criteria">評審準則</a>
              </div>
            </div>
            <a href="/2018/zh/sponsors">贊助</a>
            <a href="/2018/zh/highlights">花絮</a>
            <div className="language container" id="language">
              <div className="lang_icon">
                <img src="/2018/images/lang_icon.png" alt="" />
              </div>
              <a
                href="/2018"
                className="language_ch"
                style={{
                  fontFamily: 'Poppins',
                  padding: 0,
                  paddingLeft: 6,
                  textAlign: 'center',
                  color: '#004fad',
                  position: 'absolute',
                  borderBottom: 0,
                  display: 'inline-block',
                }}
              >
                En
              </a>
            </div>
          </div>
          <a
            id="click"
            href="#"
            style={{ fontSize: 15 }}
            className="icon"
            onClick={(e) => {
              e.preventDefault();
              (window as any).myFunction?.();
            }}
          >
            <i className="fa fa-bars" />
          </a>
        </div>
      </div>

      <div id="larger_wrapper">
        <div className="wrapper">
          <div className="head_banner">
            <div className="KV">
              <div className="KV_envir a">
                <img src="/2018/images/awards_KV.jpg" alt="" />
              </div>
            </div>
          </div>

          <div className="left_head_banner">
            <div className="small_wrapper">
              <a href="/2018/zh" className="head_logo">
                <img src="/2018/images/head_logo.png" alt="" />
              </a>
            </div>
            <div className="head_logo_mobile">
              <img src="/2018/images/head_logo_3.png" alt="" />
            </div>
            <div className="small_wrapper_mobile" />
          </div>
        </div>
      </div>

      <div className="wave_bg_pattern" />

      <div className="para_introduction">
        <h1>峰會</h1>

        <div className="youtubevideowrap">
          <div className="video_container">
            <iframe
              src="https://www.youtube.com/embed/PHuWA7rboj8?showinfo=0&rel=0"
              frameBorder={0}
              allowFullScreen
            />
          </div>
        </div>

        <div className="center_introduction">
          <p className="p1">
            以「智慧創新引領更理想香港」為題的「香港智慧城市峰會2018」暨「香港智慧城市大獎 2018」將探討如何通過更佳的管治和規劃，技術與社會創新，以及城市中持份者相互合作，實現更宜居、更具持續性的生活環境。社會大眾、各行各業及不同背景的人士將聚首於這香港的重點活動—「香港智慧城市峰會暨智慧城市大獎2018」，分享願景，共同探索、創造綜合城市解決方案，以締造更可持續發展的未來。
          </p>
          <a
            href="http://projects.etnet.com.hk/form/index.php?id=488"
            target="_blank"
            rel="noreferrer"
            aria-label="立即登記"
          />
        </div>
      </div>

      <div
        className="schedule_container animate"
        data-animate="fadeIn"
        data-duration="1.0s"
        data-delay="0.3s"
        data-offset="100"
      >
        <h2>峰會議程</h2>

        <div className="schedule_0">
          <div className="description">會議</div>
        </div>

        <div className="schedule">
          <div className="timeslot">08:30 - 09:00</div>
          <div className="session_description">
            <div className="session_description_title">登記</div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">09:00 - 09:15</div>
          <div className="session_description">
            <div className="session_description_title">開幕致辭</div>
            <div className="session_description_info">
              <div className="speaker_host">講者 | </div> 史秀美女士,
              <p3>經濟通有限公司董事總經理及香港經濟日報執行董事 </p3>
            </div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">09:15 - 09:25</div>
          <div className="session_description">
            <div className="session_description_title">嘉賓致辭*</div>
            <div className="session_description_info">
              <div className="speaker_host">講者 | </div> 鄧淑明博士, JP,
              <p3>智慧城市聯盟創辦人及榮譽會長</p3>
            </div>
          </div>
        </div>

        <div className="session1_container">
          <div className="schedule_0 session1">
            <div className="description">專題演講環節 1</div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">09:25 – 09:45</div>
            <div className="session_description">
              <div className="session_description_title">當韋志成九十歲時*</div>
              <div className="session_description_info">
                <div className="speaker_host">演講嘉賓 | </div> 韋志成先生, GBS, JP, FHKEng,
                <p3>市區重建局的行政總監</p3>
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">09:45 – 10:05</div>
            <div className="session_description">
              <div className="session_description_title">香港的智慧能源選擇及可交互能源*</div>
              <div className="session_description_info">
                <div className="speaker_host">演講嘉賓 | </div> 柏恩司先生,
                <p3>中電控股創新高級總監</p3>
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">10:05 - 10:25</div>
            <div className="session_description">
              <div className="session_description_title">掌握大數據與智能科技建立新世代機場</div>
              <div className="session_description_info">
                <div className="speaker_host">演講嘉賓 | </div> 歐陽顯宏先生,
                <p3>香港機場管理局智能機場部總經理</p3>
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">10:25 - 10:45</div>
            <div className="session_description">
              <div className="session_description_title">香港人口老化與智慧型健康的發展</div>
              <div className="session_description_info">
                <div className="speaker_host">演講嘉賓 | </div> 張淑英女士,
                <p3>醫院管理局總系統經理 (資訊科技及電子化健康記錄互通系統運維)</p3>
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">10:45 – 11:05</div>
            <div className="session_description">
              <div className="session_description_title">創新科技：推動香港成為智慧城市之鑰匙</div>
              <div className="session_description_info">
                <div className="speaker_host">演講嘉賓 | </div> 譚樂文先生,
                <p3>騰訊國際業務部總經理 - 香港及台灣</p3>
              </div>
            </div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">11:05 – 11:25</div>
          <div className="session_description">
            <div className="session_description_title">茶歇</div>
          </div>
        </div>

        <div className="session1_container session2_container">
          <div className="schedule_0 session2">
            <div className="description">專題論壇環節</div>
          </div>

          <div className="schedule session2">
            <div className="timeslot">11:25 – 11:45</div>
            <div className="session_description">
              <div className="session_description_title">
                專題論壇 1: 智慧供應鏈如何造就智慧消費者
              </div>
              <div className="session_description_info">
                <div className="speaker_host" style={{ display: 'block', margin: '3px 0px' }}>
                  嘉賓 |{' '}
                </div>
                何雅賢女士,
                <p3>香港貨品編碼協會首席顧問;</p3>
                <br />
                張敏怡女士,
                <p3>微际媒（上海）貿易有限公司首席供應官/顧問;</p3>
                <br />
                羅孟慶先生,
                <p3>新佛香食品有限公司董事總經理及壹品豆漿創辦人</p3>
                <br />
                <div className="speaker_host">主持人 | </div> 吳顯光先生,
                <p3>安永大中華區數位化中心主管</p3>
              </div>
            </div>
          </div>

          <div className="schedule session2">
            <div className="timeslot">11:45 - 12:05</div>
            <div className="session_description">
              <div className="session_description_title">
                專題論壇 2: 在智慧經濟下推動數碼科技初創生態圈
              </div>
              <div className="session_description_info">
                <div className="speaker_host" style={{ display: 'block', margin: '3px 0px' }}>
                  嘉賓 |{' '}
                </div>
                湛家揚博士,
                <p3>香港數碼港管理有限公司公眾使命總監;</p3>
                <br />
                劉港成先生,
                <p3>香港HEYCOINS創辦人;</p3>
                <br />
                何穎翔先生,
                <p3>10 Life創辦人</p3>
                <br />
                <div className="speaker_host">主持人  | </div> 顧向聖先生,
                <p3>德勤中國審計及鑑證合夥人兼大中華IT審計及諮詢主管合夥人</p3>
              </div>
            </div>
          </div>

          <div className="schedule session2">
            <div className="timeslot">12:05 – 12:25</div>
            <div className="session_description">
              <div className="session_description_title">專題論壇 3: 香港的「智慧社區」</div>
              <div className="session_description_info">
                <div className="speaker_host" style={{ display: 'block', margin: '3px 0px' }}>
                  嘉賓 |{' '}
                </div>
                楊天寵工程師,
                <p3>香港科技園公司 (電子、信息及通訊科技群組及智慧城市科技平台);</p3>
                <br />
                羅健麟先生,
                <p3>MotherApp創辦人及行政總裁;</p3>
                <br />
                羅建民先生,
                <p3>NVIDIA人工智能技術中心總經理</p3>
                <br />
                <div className="speaker_host">主持人 | </div> 朱雅儀女士,
                <p3>畢馬威中國資本市場新經濟行業及生命科學主管</p3>
              </div>
            </div>
          </div>
        </div>

        <div className="session1_container">
          <div className="schedule_0 session1">
            <div className="description">專題演講環節 2</div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">12:25 - 12:45</div>
            <div className="session_description">
              <div className="session_description_title">大數據在數碼轉型之應用</div>
              <div className="session_description_info">
                <div className="speaker_host">演講嘉賓 | </div> 車品覺先生,
                <p3>紅杉中國基金專家合夥人</p3>
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">12:45 – 14:40</div>
            <div className="session_description">
              <div className="session_description_title">
                午宴
                <img style={{ verticalAlign: 'middle', paddingLeft: 5 }} src="/2018/images/luncheon.png" alt="" />
              </div>
            </div>
          </div>

          <div className="schedule session1">
            <div className="timeslot">13:00 - 13:15</div>
            <div className="session_description">
              <div className="session_description_title">香港智慧城市發展藍圖*</div>
              <div className="session_description_info">
                <div className="speaker_host">演講嘉賓 | </div> 楊德斌先生, JP,
                <p3>香港特別行政區政府資訊科技總監 </p3>
              </div>
            </div>
          </div>

          <div className="schedule">
            <div className="timeslot">13:15 - 13:20</div>
            <div className="session_description">
              <div className="session_description_title">標準-連繫智慧城市的要素</div>
              <div className="session_description_info">
                <div className="speaker_host">講者 | </div> 林潔貽女士, JP, FCILT,
                <p3>香港貨品編碼協會總裁</p3>
              </div>
            </div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">13:20 – 14:35</div>
          <div className="session_description">
            <div className="session_description_title">頒獎典禮</div>
          </div>
        </div>

        <div className="schedule">
          <div className="timeslot">14:35 - 14:40</div>
          <div className="session_description">
            <div className="session_description_title">頒獎典禮完結</div>
          </div>
        </div>

        <div className="please_note" style={{ fontSize: 12, paddingTop: 5 }}>
          以上議程如有任何更改，恕不另行通知 <br />
          <br />
          <span style={{ fontSize: 16 }}>*</span>註: 有 “ <span style={{ fontSize: 16 }}>*</span> ” 符號代表演講是英文
        </div>
      </div>

      <Footer2018 lang="zh" />
    </>
  );
};

export default Agenda2018Zh;

